import React, { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { useQueryClient } from 'react-query'
import { useResponsive } from 'utils/hooks'
import { Avatar, Dropdown, Menu, Typography } from 'antd'
import { compareWithJSON } from 'utils/helper'
import { first } from 'lodash-es'
import styles from './style.module.scss'

const { Text } = Typography

const CompanySelector = ({ onChangeCompany, companies, selectedCompany, isCanAddCompany }) => {
  const { isMobileView } = useResponsive()
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()
  const queryClient = useQueryClient()
  const [visibleDropdown, setVisibleDropdown] = useState(false)

  useEffect(() => {
    const header = document.querySelector('header.ant-layout-header')

    if (!header) {
      return
    }

    if (isMobileView) {
      header.classList.add(styles.lineHeightInherit)
    } else {
      header.classList.remove(styles.lineHeightInherit)
    }
  }, [isMobileView])

  const handleOpenChange = useCallback((visible) => setVisibleDropdown(visible), [])

  const changeCompany = useCallback(
    ({ key }) => {
      if (key === 'list') {
        dispatch(push('/companies'))
      } else if (key === 'add') {
        dispatch(push('/companies/add'))
      } else if (companies.selectedEndpoint !== key) {
        onChangeCompany(key, () => {
          // Clear all cache from react-query to prevent sharing cache data between company.
          // Sharing cache data will cause current company use last cache data from previous company
          // until current fetching success
          queryClient.clear()
        })
      }
    },
    [companies, dispatch, onChangeCompany, queryClient],
  )

  const items = useMemo(() => {
    const newItems = companies.companies.map((item) => {
      return {
        key: item.endpoint,
        label: item.name,
      }
    })
    if (isCanAddCompany) {
      newItems.push({
        type: 'divider',
        key: Math.random(),
      })
      if (companies.companies.length > 1) {
        newItems.push({
          key: 'list',
          label: formatMessage({ id: 'companies.company_list' }),
        })
      } else {
        newItems.push({
          key: 'add',
          label: formatMessage({ id: 'companies.add_company' }),
        })
      }
    }

    return newItems
  }, [companies, formatMessage, isCanAddCompany])

  const companyName = selectedCompany[0] ? selectedCompany[0].name : ''

  const langMenu = (
    <Menu
      className={styles.menu}
      selectedKeys={[companies.selectedEndpoint]}
      onClick={changeCompany}
      items={items}
    />
  )
  return (
    <Dropdown
      arrow
      placement="bottomRight"
      popupRender={() => langMenu}
      trigger={['click']}
      open={visibleDropdown}
      onOpenChange={handleOpenChange}
    >
      <div className={`${styles.dropdown} ${visibleDropdown ? styles.open : ''}`}>
        {isMobileView ? (
          <Avatar
            style={{
              backgroundColor: '#87d068',
            }}
            size="small"
          >
            {first(companyName)?.toUpperCase()}
          </Avatar>
        ) : (
          <Text ellipsis className={`${styles.companyName} text-uppercase text-right`} strong>
            {companyName || ''}
          </Text>
        )}
      </div>
    </Dropdown>
  )
}

export default memo(CompanySelector, compareWithJSON)
